import React, { useState } from "react";
import $ from 'jquery';
import bootbox from 'bootbox';
import Toastr from 'toastr';
import logo from "./../assets/img/favicon-dark.png";
import Loading from "../components/Loading";

function PasswordRenewal() {

    let challenge = new URLSearchParams(window.location.search);
    let user_login = challenge.get('username');

    const [password, setPassword] = useState('');
    const [otp, setOtp] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    const [verifying, setVerifying] = useState(false);

    const renewPassword = () => {
        if (verifying)
            return;

        let allowedPattern = /^[0-9a-zA-Z!#@$]+$/;

        if (password.length < 8 || !allowedPattern.test(password)) {
            Toastr.error('Password should satisfy below: <br> 1. can contain alphabets, <br> 2. can contain numeric characters, <br> 3. can contain ! # @ $, <br> 4. should atleast be of 8 chars length', "Failure");
            return;
        }
        setVerifying(true);
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/reset-pwd-challenge',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({
                    operation: 'renew-password',
                    form_input: {
                        password: password,
                        confirm_password: confirm_password,
                        user_login: user_login,
                        pwd_expiry_token: otp
                    }
                }),
                dataType: "json"
            }
        ).then((res) => {
            setVerifying(false);
            if (res && res.status) {
                switch (res.status.code) {
                    case 200:
                        bootbox.alert('Your password has been successfully reset!', () => {
                            window.location = "/";
                        })
                        break;

                    case 400:
                        bootbox.alert(res.status.message === 'SAME-AS-OLD-PWD' ? '<div><i class="fa fa-lg fa-info-circle text-danger"></i> Renew password can not be same as old password</div>' : 'Error while password reset. <br>Please contact SiteKick Support.', () => {
                        })
                        break;

                    default:
                        bootbox.alert('Error while password reset. <br>Please contact SiteKick Support.', () => {
                        });
                        break;
                }
            } else {
                bootbox.alert('Error while password reset. <br>Please contact SiteKick Support.', () => {
                });
            }
            $('.btn-reset-pwd').removeClass('btn-loading');
        }, (err) => {
            setVerifying(false);
            $('.btn-reset-pwd').removeClass('btn-loading');
            bootbox.alert('Error while password reset. <br>Please contact SiteKick Support.', () => {
            });
        });

    }

    const handleInputChange = (e) => {
        const target = e.target;
        switch (target.name) {
            case "password":
                setPassword(target.value);
                break;
            case "confirm_password":
                setConfirmPassword(target.value);
                break;
            case "otp":
                setOtp(target.value);
                break;
            default:
                break;
        }
    };

    return (
        <React.Fragment>
            <div className="container mt-5" style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <div className="row">
                    <div className="col-md-12 col-xs-12 p-2">
                        <div className="text-center">
                            <span className="logo-font font-size-20 text-app-2 strong">
                                <img
                                    className="pb-1 "
                                    src={logo}
                                    alt="logo"
                                    style={{ width: "30px", marginRight: "10px" }}
                                />
                                SiteSupt OnDemand
                            </span>
                        </div>
                        <br />
                        <div className="card m-4" style={{ width: "20rem" }}>
                            <div className="card-body">
                                <h6 className="text-center text-bold">Update Password</h6>
                                <div className="d-flex align-items-center flex-column mt-5">
                                    <div>
                                        <label className="py-0 my-0 mt-3 text-app-2 font-size-16">New Password </label>
                                        <input
                                            className="form-control"
                                            style={{ width: "18rem" }}
                                            type="password"
                                            name="password"
                                            value={password}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                            placeholder="Password"
                                        />
                                    </div>
                                    <div>
                                        <label className="py-0 my-0 mt-3 text-app-2 font-size-16"> Confirm New Password </label>
                                        <input
                                            className="form-control"
                                            style={{ width: "18rem" }}
                                            type="password"
                                            name="confirm_password"
                                            value={confirm_password}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                            placeholder="Confirm Password"
                                        />
                                    </div>
                                    <div>
                                        <label className="py-0 my-0 mt-3 text-app-2 font-size-16"> Verification Code </label>
                                        <input
                                            className="form-control"
                                            style={{ width: "18rem" }}
                                            type="number"
                                            name="otp"
                                            value={otp}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                            placeholder="Verification Code"
                                        />
                                    </div>
                                </div>
                                <div className="text-right">
                                    <button disabled={!(password.trim()).length > 0 || !(confirm_password.trim()).length > 0 || password !== confirm_password || otp.length === 0} className="btn btn-sm btn-app-2 mt-2 btn-reset-pwd" onClick={() => renewPassword()}>{verifying ? <Loading>Applying ...</Loading> : 'Submit'}</button>
                                </div>
                                <div className="left-right mt-3">
                                    <i className="fas fa-arrow-left text-app-2"></i>
                                    <a href="./"> Back to Login </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    );
}
export default PasswordRenewal;
